var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCompleted(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.0056 12.2131V5.663C24.0056 5.01873 23.4827 4.49585 22.8385 4.49585H20.6711C20.0268 4.49585 19.5039 5.01873 19.5039 5.663V8.35446",
    stroke: "#4EAEA5",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.49609 13.4992L13.4808 5.79831C14.355 5.049 15.6447 5.049 16.5189 5.79831L25.5048 13.4992",
    stroke: "#4EAEA5",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.99609 12.2131V23.1704C5.99609 24.4601 7.0407 25.5047 8.3304 25.5047H13.8324",
    stroke: "#4EAEA5",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4202 26.6719C18.5198 26.6719 16.168 24.32 16.168 21.4197C16.168 18.5193 18.5198 16.1675 21.4202 16.1675C24.3217 16.1675 26.6723 18.5193 26.6723 21.4197C26.6723 24.32 24.3217 26.6719 21.4202 26.6719",
    stroke: "#4EAEA5",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M23.4941 20.3821L20.9007 22.9755L19.3438 21.4197",
    stroke: "#4EAEA5",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompleted);
export default __webpack_public_path__ + "static/media/completed.46f879dc.svg";
export { ForwardRef as ReactComponent };